module.exports = __webpack_public_path__ + "static/media/step2.238fd5b5.svg";